<template>
  <div
    style="width:260px;height:200px;position:absolute;top:20vh;left:40%;z-index:999;text-align: center;background-color: rgba(7,35,59,.9);border: 1px solid rgba(41, 155, 255, .5)"
    v-show="visible">
    <i @touchstart="handleClose" @click="handleClose" class="el-icon-close close-btn"></i>
    <div style="margin-top: 15px;display: inline-block">
      <div class="title-line"
           style="background-image: linear-gradient(to right, rgba(15, 61, 104, 1), rgba(41, 155, 255, 1));"></div>
      <div class="title"> {{ deviceInfo.name }}</div>
      <div class="title-line"
           style="background-image: linear-gradient(to right, rgba(41, 155, 255, 1), rgba(15, 61, 104, 1));"></div>
    </div>
    <el-row style="padding: 15px">
      <el-col :span="7" style="text-align: right;padding-top: 10px;" v-if="deviceInfo.detailUrl">
        <img v-if="visible"
             :src="require('../../../assets/images/device/'+ deviceInfo.detailUrl +'.png')">
        <div style="margin-top: 5px;" v-if="deviceInfo.detailUrl === 'Noise'">{{ historyData[0].pointValueName }}</div>
      </el-col>
      <el-col :span="17" style="text-align: left;padding-left: 15px;">
        <div style="color: rgba(41, 155, 255, 1);font-weight: bold;">名称：{{ deviceInfo.name }}</div>
        <div style="margin-top: 10px;font-size: 0.9rem">
          <el-row>
            状态：<span>{{ deviceInfo.status === 0 ? '正常' : '异常' }}</span>
            <img src="../../../assets/images/comprehensive/严重告警.png" style="margin-top: -5px;"
                 v-if="deviceInfo.status !== 0">
          </el-row>
          <el-row>类型：{{ deviceInfo.typeCnName }}</el-row>
          <el-row>品牌：{{ deviceInfo.brandCnName }}</el-row>
          <el-row>型号：{{ deviceInfo.modelCnName }}</el-row>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {getHistoryByDevicePoint} from "@/network/measuring-point-history";

export default {
  name: "DeviceDetailBox",
  props: {
    boxVisible: {
      type: Boolean,
      default: false,
    },
    deviceInfo: {
      type: Object,
      default: () => {
      }
    },
  },
  watch: {
    boxVisible: {
      handler(val) {
        this.visible = val
      }
    },
    deviceInfo() {
      this.deviceId = this.deviceInfo.id
      this.getPointData();
    }
  },
  mounted() {
    this.getPointData();
  },
  created() {
    this.$store.dispatch('addIntervalObj', {'getDivData:5000': this.getPointData})
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getDivData')
  },
  data() {
    return {
      visible: false,
      component: null,
      width: '',
      pointCodes: [],
      historyData: [],
      deviceId: null
    };
  },
  methods: {
    handleClose() {
      this.visible = false
      this.$emit('boxClose', this.visible)
    },
    getPointData() {
      getHistoryByDevicePoint({
        deviceId: this.deviceId,
        pointCodes: this.pointCodes
      }).then(res => {
        if (res.code === 0) {
          this.historyData = res.data.filter(item => item.pointName && item.pointName.trim() !== '');
        }
      })
    }
  },
}
</script>

<style scoped>

.title {
  display: inline;
  font-size: 1rem;
  font-weight: bold;
  margin: 5px;
}

.close-btn {
  float: right;
  margin-top: 5px;
  margin-right: 8px;
  font-weight: normal;
  color: #FFFFFF;
}

.close-btn:hover {
  cursor: pointer;
}

.title-line {
  width: 50px;
  height: 2px;
  display: inline-block;
  margin-bottom: 5px;
  border-radius: 15px;
}
</style>
